var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.readOnly ? 'froalaView' : 'froala',{tag:"component",class:{'border p-2 bg-gray-150':_vm.readOnly},attrs:{"config":_vm.froalaConfig},model:{value:(_vm.valueFromProp),callback:function ($$v) {_vm.valueFromProp=$$v},expression:"valueFromProp"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b52346ac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/framework/GtcFtieFroala.vue
// module id = null
// module chunks = 